import React, { useEffect } from 'react';
import Dragger from 'draggerjs'
import { SectionWithCode, Note } from 'Templates';
import * as code from '../StringCodes'; 

export const Cloning = () => {

    useEffect(() => {
        let clone
        const cloningAlgorithm = (e, elementToInsert) => {
            const droppable = e.droppable && e.droppable.closest('.draggable-box')
            const currentDroppable = e.currentDroppable 
            /*prevent cloning in the same droppable-area*/
            if(e.target.closest('.droppable-area') === currentDroppable) return;
            if(droppable && currentDroppable 
                && droppable !== elementToInsert 
                && droppable !== currentDroppable) {
                const droppableRect = droppable.getBoundingClientRect()
                /*the clone positioning is base on x axis*/
                const isBefore = e.clientX - droppableRect.left < droppableRect.width/2
                const next = droppable.nextElementSibling
                if(!next && !isBefore) {
                    currentDroppable.appendChild(elementToInsert)
                }
                currentDroppable.insertBefore(elementToInsert, isBefore ? droppable : next )
            } else if(currentDroppable && e.droppable === currentDroppable){
                currentDroppable.appendChild(elementToInsert)
            }
        }

        const dragger = new Dragger('#drag-cloning', {
            draggable: '.draggable-box',
            droppable: '.droppable-area',
        })
        dragger.on('dragstart', (e) => {
            const target = e.target
            if(e.isDraggableElement) {
                e.preventDefault() 
                clone = target.cloneNode(true)
                clone.classList.add('drag-clone')
                target.classList.add('grabbed')
                target.classList.add('n-float')
                target.classList.remove('n-flat') 
                
            }
           
        })
        dragger.on('dragover', (e) => { 
            cloningAlgorithm(e, clone)
        }) 
        dragger.on('dragenter', (e) => {
            if(e.isDraggableElement && e.target.parentElement !== e.currentDroppable) { 
                e.currentDroppable.classList.add('n-engrave') 
            } 
        })
        dragger.on('dragexit', (e) => {
            if(e.isDraggableElement && e.target.parentElement !== e.currentDroppable) { 
                e.currentDroppable.classList.remove('n-engrave') 
            }
            /*remove clone when exiting*/
            e.currentDroppable.contains(clone) && clone.remove()
        })
        dragger.on('drop', (e) => {
            if(e.isDraggableElement) { 
                cloningAlgorithm(e, e.target) 
                e.currentDroppable.classList.remove('n-engrave') 
            } 
        })
        dragger.on('dragend', (e) => {
            const target = e.target
            if(e.isDraggableElement) { 
                clone && clone.remove()
                /*async it to show transition*/
                setTimeout(() => {
                    target.classList.add('n-flat')
                    target.classList.remove('n-float')
                    target.classList.remove('grabbed')
                },0)
            }
        })
        return () => dragger.destroy()
    }, [])

    return (
        <>  
            <SectionWithCode
                readonly
                title='Cloning'
                context='you can clone as well.'
                code={code.Cloning}
            >
                <div id="drag-cloning" className="drag-container" data-example>  
                    <div className="droppable-area n-no-shadow n-border-color">
                        <div className="draggable-box n-no-shadow n-flat" id="draggable-1">
                            <h1>1</h1>
                        </div>
                        <div className="draggable-box n-no-shadow n-flat" id="draggable-2">
                            <h1>2</h1>
                        </div> 
                    </div>
                    <div className="droppable-area n-no-shadow n-border-color">
                        <div className="draggable-box n-no-shadow n-flat" id="draggable-3">
                            <h1>3</h1>
                        </div>
                        <div className="draggable-box n-no-shadow n-flat" id="draggable-4">
                            <h1>4</h1>
                        </div>
                    </div>
                </div>
                <Note
                    variant='warning'
                    title='remember'
                    context={<>When using <b>droppable</b> make sure to add <b>[hidden] {'{'} display: none !important; {'}'}</b> in your stylesheet. due to some changes in browsers which <b>hidden</b> property gets overridden.</>}
                    style={{ marginTop: '20px' }}
                />
            </SectionWithCode>
        </>
    );
}